import React from "react";
import { motion } from "framer-motion";
import { MdCloudUpload } from "react-icons/md";

interface VantaIntegrationBannerProps {
  connected: boolean;
  onPush: () => void;
  onConnect: () => void;
  isLoading: boolean;
  disabled?: boolean;
}

const VantaIntegrationBanner: React.FC<VantaIntegrationBannerProps> = ({
  connected,
  onPush,
  onConnect,
  isLoading,
  disabled = false
}) => {
  if (connected === null) return null;

  return (
    <motion.div
      className={`bg-white rounded-xl p-5 shadow-sm border border-slate-100 flex flex-col md:flex-row items-center justify-between gap-4 transition-all ${
        disabled ? "opacity-60 grayscale select-none cursor-not-allowed" : ""
      }`}
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
    >
      <div className="flex items-center gap-4">
        <div className="h-12 w-12 rounded-2xl bg-emerald-50 flex items-center justify-center overflow-hidden p-2 border border-emerald-100">
          <img src="/vanta-logo.jpg" alt="Vanta" className="w-full h-full object-contain mix-blend-multiply" />
        </div>
        <div>
          <div className="flex items-center gap-2">
            <h4 className="text-sm font-black text-slate-800">Vanta Integration</h4>
            <span className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[10px] font-black uppercase tracking-wider ${connected ? 'bg-emerald-50 text-emerald-600' : 'bg-slate-100 text-slate-400'}`}>
              <span className={`h-1.5 w-1.5 rounded-full ${connected ? 'bg-emerald-500 animate-pulse' : 'bg-slate-400'}`}></span>
              {connected ? 'Connected' : 'Disconnected'}
            </span>
          </div>
          <p className="text-xs text-slate-400 font-medium">
            {connected
              ? "Sync your security data to keep Vanta compliance up to date"
              : "Connect your Vanta account to automate compliance data syncing"}
          </p>
        </div>
      </div>

      <button
        onClick={connected ? onPush : onConnect}
        disabled={isLoading || disabled}
        className={`flex items-center gap-2 rounded-2xl bg-[#010D2C] px-6 py-3 text-xs font-black text-white shadow-xl shadow-slate-200 hover:bg-slate-800 transition-all hover:-translate-y-0.5 disabled:opacity-50 disabled:translate-y-0 ${
          disabled ? "pointer-events-none" : ""
        }`}
      >
        <MdCloudUpload className="h-4 w-4" />
        {isLoading ? "Syncing..." : (connected ? "Push Data to Vanta" : "Connect Vanta")}
      </button>
    </motion.div>
  );
};

export default React.memo(VantaIntegrationBanner);

